module.exports = __webpack_public_path__ + "static/media/country_lb.50ddf1d7.webp";